import cx from 'classnames'

import { paperStyles } from '../../libs/paperStyles'
import { zIndexStyles } from '../../libs/zIndexStyles'
import { typographyStyles } from '../../structure/typography/styles' // direct import to prevent circular reference

export const selectStyles = {
  options: cx(
    'outline-hidden absolute overflow-auto rounded-lg p-1 shadow-lg flex flex-col gap-y-1',
    'max-h-[min(340px,50dvh)]!', // headless ui sets max height to 100vh so we need a bang
    '[--anchor-gap:var(--spacing)]', // ensure tiny space between options and the input to show focus styles nicely
    paperStyles({ ringColor: 'grey' }),
    zIndexStyles('popovers'),
  ),
  option: ({
    hasFocus,
    isSelected,
    isDisabled,
  }: {
    hasFocus: boolean
    isSelected: boolean
    isDisabled: boolean
  }) => {
    const state =
      (isDisabled && 'disabled') ||
      (`${isSelected ? 'selected' : 'notSelected'}_${hasFocus ? 'focus' : 'notFocus'}` as const)

    return cx(
      'gap-1 rounded-lg cursor-pointer flex items-center justify-between px-2 py-1.5 transition-colors',
      {
        disabled: cx(
          typographyStyles({ intensity: 'tertiary' }),
          'cursor-default!',
        ),
        selected_notFocus: 'text-primary-50 bg-primary',
        selected_focus: 'text-primary-50 bg-primary-600',
        notSelected_notFocus: 'text-amaze-ink dark:text-amaze-inkBright',
        notSelected_focus:
          'text-amaze-ink bg-primary/10 dark:text-amaze-inkBright',
      }[state],
    )
  },
  fallbackMessage: cx(
    'px-2 py-1.5',
    typographyStyles({ intensity: 'secondary' }),
  ),
  inputIconsWrapper: cx('absolute inset-y-0 inset-e-1 flex items-center'),
}
